import React from 'react'
import { Row } from 'antd'
import { CustomCol } from 'src/components'
import { UsersAdmin } from 'src/core/models'
import { useWindowSize } from 'src/app/hooks'
import { useTranslation } from 'next-i18next'
import UserAdminSection from './UserAdminSection/UserAdminSection'
import { leftSideSections, rigthSideSections } from './user-admin-details.helpers'

const UserAdminDetails: React.FC<{ user: UsersAdmin }> = ({ user }) => {
  const { t } = useTranslation()
  const leftItems = leftSideSections(t, user)
  const rigthItems = rigthSideSections(t, user)
  const { width } = useWindowSize()
  const isMobile = width <= 800

  return <>
    <Row>
      <CustomCol className='mr-5' lg={11}>
        <UserAdminSection items={leftItems} />
      </CustomCol>
      <CustomCol className={!isMobile ? 'ml-5' : 'mt-5'} lg={12}>
        <UserAdminSection items={rigthItems} />
      </CustomCol>
    </Row>
  </>
}

export default UserAdminDetails
